/**
 * Login
 */
import React from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Segment } from 'semantic-ui-react';

import { ErrorBoundary } from '../../workspaces/redux-error-boundary';

// Components
import ErrorBoundaryAlert from '../../components/ErrorBoundaryAlert';
import LoginForm from './components/LoginForm';

// Environment
const { REACT_APP_PROJECT_NAME, REACT_APP_VERSION } = process.env;

export class Login extends React.PureComponent<*> {
    render() {
        return (
            <ErrorBoundary
                namespace="Login"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <Helmet>
                    <title>
                        {'Login - '}
                        {REACT_APP_PROJECT_NAME}
                    </title>
                </Helmet>
                <Grid textAlign="center" padded style={{ height: '100%' }}>
                    <Grid.Column
                        style={{ maxWidth: 450 }}
                        verticalAlign="middle"
                    >
                        <Segment textAlign="left">
                            <LoginForm
                                title={`Login to your ${REACT_APP_PROJECT_NAME} account`}
                            />
                        </Segment>
                        <p style={{ textAlign: 'center' }}>
                            v{REACT_APP_VERSION}
                        </p>
                    </Grid.Column>
                </Grid>
            </ErrorBoundary>
        );
    }
}

export default Login;
